<div class="container-fluid">
  <div class="header-container">
    <div class="page-header">
      <span></span>Rental Products Import
    </div>
  </div>

  <div class="flex">
    <div class="wizard">
      <ul>
        <li>
          <a class="first">
            <span class="wizard-step" [ngClass]="{'active': step===1, 'complete' : step > 1}">
              <span [ngClass]="{'inner-circle':step === 1}"></span>
              <span [ngClass]="{'hide':step > 1}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===1, 'complete' : step > 1}">{{
              'bikeshop.rental_products_imports.step1' | translate}}</span>
          </a>
        </li>
        <li>
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===2, 'complete' : step > 2}">
              <span [ngClass]="{'inner-circle':step === 2}"></span>
              <span [ngClass]="{'hide':step > 2}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===2, 'complete' : step > 2}">{{
              'bikeshop.rental_products_imports.step2' | translate}}</span>
          </a>
        </li>
        <li class="last">
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===3}">
              <span [ngClass]="{'inner-circle':step === 3}"></span>
              <span [ngClass]="{'hide':step > 3}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===3, 'complete' : step > 2}">{{
              'bikeshop.rental_products_imports.step3' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="invalidFileFormat"
       class="validation-issues">{{ "bikeshop.rental_products_imports.invalid_file_format" | translate }}</div>
  <div class="margin-top-16 content download-container" *ngIf="step === 1">
    <div>
      <div>
        <a href="/assets/excel-templates/Rental Product Import Template_updated.xlsx" target="_blank"
           download="Rental Product Import Template.xlsx">
          <button pButton class="full-width"
                  label="{{ 'bikeshop.rental_products_imports.download_template' | translate }}"></button>
        </a>
      </div>
      <div class="margin-top-16">
        <button pButton class="full-width accent"
                label="{{ 'bikeshop.rental_products_imports.select_file' | translate }}"
                (click)="fileUpload.click()"></button>
        <input #fileUpload type="file" accept=".xlsx" style="display: none;" (change)="prepareFile($event)">
      </div>
    </div>
  </div>

  <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 2">
    <div class="validation-issues" *ngIf="hasValidationErrors">
      {{ 'bikeshop.rental_products_imports.has_validation_errors' | translate }}
    </div>

    <p-table #servicesTable [columns]="columns" [value]="data">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
              [ngStyle]="{'width': 'auto'}">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-columns="columns">
        <tr [pSelectableRow]="item">
          <td *ngFor="let col of columns"
              [ngClass]="{ 'invalid-row' : item['validationStatus'] !== 'Valid' }">
            <div>
              <ul *ngIf="col.type === 'status' && item[col.field] !== 'Valid'"
                  [innerHTML]="item[col.field]" class="invalid"></ul>
            </div>
            <div *ngIf="col.type === 'status' && item[col.field] === 'Valid'">
              <span class="fa fa-check-square-o"></span>
            </div>
            <div *ngIf="col.type !== 'status'">
              {{
              col.type === "date" && item[col.field].length < 20 && item[col.field] !== '-'
                ? (item[col.field] | date) :
                item[col.field]
              }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="content margin-top-16 margin-bottom-16" *ngIf="step == 3">

    <div class="margin-bottom-16">
      <p-progressBar [value]="progress"></p-progressBar>
    </div>

    <p-table #servicesTable [columns]="columnsImported" [value]="importData">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columnsImported" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
              [ngStyle]="{'width': 'auto'}">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-columns="columnsImported">
        <tr [pSelectableRow]="item">
          <td *ngFor="let col of columnsImported"
              [ngClass]="{ 'invalid-row' : item['validationStatus'] !== 'Valid' }">
            <div *ngIf="col.type === 'status' && item[col.field] === null">
              <span class="fa fa-spinner fa-pulse"></span>
            </div>
            <div
              *ngIf="(col.type === 'status' && item[col.field] === 'bikeshop.rental_products_imports.feedback.row_imported') || (col.type === 'status' && item[col.field] === 'bikeshop.rental_products_imports.feedback.row_already_exists')">
              <span class="fa fa-check-square-o"></span>
              {{ item[col.field] | translate }}
            </div>
            <div *ngIf="col.type === 'status' && item[col.field] !== null &&
                      item[col.field] !== 'bikeshop.rental_products_imports.feedback.row_imported' &&
                      item[col.field] !== 'bikeshop.rental_products_imports.feedback.row_already_exists'">
              <ul [innerHTML]="item[col.field] | translate" class="invalid"></ul>
            </div>
            <div *ngIf="col.type !== 'status'">
              {{
              col.type === "date" && item[col.field].length < 20 && item[col.field] !== '-'
                ? (item[col.field] | date) :
                item[col.field]
              }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- <p-table #servicesTable [columns]="columns" [value]="importData">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-service let-columns="columns">
        <tr [pSelectableRow]="service">
          <td *ngFor="let col of columns" [ngClass]="{ 'invalid-row' : service['Status'] !== 'Valid' }" [ngStyle]="{'width': col.field === 'Notes' ? '250px' : 'auto'}">
            <div *ngIf="col.type === 'status' && service[col.field] === null">
              <span class="fa fa-spinner fa-pulse"></span>
            </div>
            <div *ngIf="col.type === 'status' && service[col.field] === 'Imported'">
              <span class="fa fa-check-square-o"></span>
            </div>
            <div *ngIf="col.type === 'status' && service[col.field] !== null && service[col.field] !== 'Imported'"><ul [innerHTML]="service[col.field] | translate" class="invalid"></ul></div>
            <div *ngIf="col.type === 'bikeSummary'"><ul [innerHTML]="service[col.field]" class="bike-summary"></ul></div>
            <div *ngIf="col.type === 'notes'"><ul [innerHTML]="service[col.field]" class="bike-summary"></ul></div>
            <div *ngIf="col.type !== 'status' && col.type !== 'bikeSummary' && col.type !== 'notes'">
              {{
                col.type === "date" && (service[col.field] !== null || service[col.field] !== undefined) ? (service[col.field] | date : 'medium') :
                service[col.field]
              }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>     -->
  </div>

</div>

<div class="bottom-sheet" *ngIf="step == 2">
  <div class="flex">

    <div class="right flex">
      <button pButton class="full-width alternate" (click)="resetWizard()"
              label="{{ 'bikeshop.rental_products_imports.reset_wizard' | translate }}"></button>

      <div style="min-width: 200px;margin-left: 32px">
        <button pButton class="full-width accent" (click)="beginImport()"
                label="{{ 'bikeshop.rental_products_imports.begin_import' | translate }}"></button>
      </div>
    </div>
  </div>
</div>

<div class="bottom-sheet" *ngIf="step == 3 && !importing">
  <div class="flex">
    <div class="right flex">
      <button pButton class="full-width alternate" (click)="resetWizard()"
              label="{{ 'bikeshop.rental_products_imports.import_another_file' | translate }}"></button>

      <div style="min-width: 200px;margin-left: 32px">
        <button pButton class="full-width accent" (click)="backToProducts()"
                label="{{ 'bikeshop.rental_products_imports.back_to_products' | translate }}"></button>
      </div>

    </div>
  </div>
</div>
